import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";
import TruncatedText from "shiitake";

import { UitkFigure, UitkImage } from "uitk-react-images";
import { UitkText } from "uitk-react-text";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import {
  UitkCard,
  UitkCardImageLayout,
  UitkCardMedia,
  UitkCardContent,
  UitkCardTextSegment,
  UitkCardLink,
  UitkCardSectionSeparatorType,
} from "uitk-react-cards";

import { getAuthorFromCityStayedAtHotelText, getPostedAgoText } from "../../hotelRecentReviewsUtils";
import { TrackedLink } from "components/utility/analytics/TrackedLink";

import {
  HotelRecentReviewsFlexModuleResult,
  HotelReview,
} from "typings/microserviceModels/hotel-recent-reviews-flex-module";

const ThumbnailImageLeftCard = (props: { model: HotelRecentReviewsFlexModuleResult; hotel: HotelReview }) => {
  const { model, hotel } = props;
  const { subheadingForThumbnailImageLeftCardView, brandName } = model;
  const {
    hotelName,
    hotelImageUrl,
    hotelInfositeUrl,
    date: reviewPostedDate,
    rating,
    reviewTitle,
    reviewText,
    authorName,
    authorLocation,
  } = hotel;

  const { formatText } = useLocalization();

  const reviewTitleToDisplay = () => {
    if (subheadingForThumbnailImageLeftCardView === "brandVerifiedReview") {
      return (
        <UitkText className="uitk-type-heading-400 all-b-margin-two">
          {formatText("hotelRecentReviews.verifiedBrandReview", brandName)}
        </UitkText>
      );
    }

    return <UitkText className="uitk-type-heading-400 all-b-margin-two">{reviewTitle}</UitkText>;
  };

  return (
    <UitkCard imageLayout={UitkCardImageLayout.LEFT}>
      <UitkCardContent>
        <UitkCard imageLayout={UitkCardImageLayout.LEFT}>
          <UitkCardMedia>
            <UitkFigure ratio={UitkFigure.AspectRatio.R4_3}>
              <UitkImage src={hotelImageUrl} alt={hotelName} placeholderImage={true} />
            </UitkFigure>
          </UitkCardMedia>
          <UitkCardContent className="fullHeight">
            <UitkLayoutFlex
              direction="column"
              justifyContent="space-between"
              className="all-x-padding-three all-y-padding-three"
            >
              <UitkText className="uitk-type-heading-500 truncate-lines-2">{hotelName}</UitkText>
              <UitkLayoutFlex direction="column">
                <UitkText size={300}>{formatText("hotelRecentReviews.ratingOutOf5", rating)}</UitkText>
                <UitkText size={200}>{getPostedAgoText(reviewPostedDate)}</UitkText>
              </UitkLayoutFlex>
            </UitkLayoutFlex>
          </UitkCardContent>
        </UitkCard>

        <UitkCardTextSegment separator={UitkCardSectionSeparatorType.TOP}>
          {reviewTitleToDisplay()}
          <TruncatedText
            lines={2}
            renderFullOnServer={true}
            overflowNode={"\u2026\u0022"}
            className="uitk-type-paragraph-300 all-b-margin-two"
          >
            {`\u0022${reviewText}\u0022`}
          </TruncatedText>
          <UitkText size={200} className="truncate-lines-2">
            {getAuthorFromCityStayedAtHotelText(authorName, authorLocation, hotelName)}
          </UitkText>
        </UitkCardTextSegment>
      </UitkCardContent>

      <UitkCardLink>
        <TrackedLink
          moduleName="hotelRecentReviews"
          rfrr="hotelInfositeLink"
          href={hotelInfositeUrl}
          data-testid={`hotel-recent-reviews-thumbnail-image-left-card-${hotelName}`}
        >
          {hotelName}
        </TrackedLink>
      </UitkCardLink>
    </UitkCard>
  );
};

export default ThumbnailImageLeftCard;
